import tippy from "tippy.js";

tippy("[data-tippy-content]");

// copy range values to input fields and vice versa
const rangeInputs = document.querySelectorAll(".calculator input[type='range']");
rangeInputs.forEach(function (rangeInput) {
	const numberInput = rangeInput.parentElement.parentElement.querySelector('input[type="number"]');
	rangeInput.addEventListener("input", (event) => {
		const value = event.target.value;
		const max = parseFloat(rangeInput.max) || 100; // Default to 100 if max is not set or invalid
		const progress = (value / max) * 100;
		rangeInput.style.background = `linear-gradient(to right, #83235f ${progress}%, #ccc ${progress}%)`;
		numberInput.value = value;
		calculateNumbers();
	});
	numberInput.addEventListener("input", (event) => {
		const value = event.target.value;
		rangeInput.value = value;
		const max = parseFloat(rangeInput.max) || 100;
		const progress = (value / max) * 100;
		rangeInput.style.background = `linear-gradient(to right, #83235f ${progress}%, #ccc ${progress}%)`;
		calculateNumbers();
	});
});

// formula
function calculateNumbers() {
	// form inputs
	const leases = document.querySelector("#leases-number").value;
	const leadToTour = document.querySelector("#conversion-lead-to-tour-number").value;
	const tourToLease = document.querySelector("#conversion-tour-to-lease-number").value;
	const ilsLeadCost = document.querySelector("#cost-per-ils-number").value;
	const ppcLeadCost = document.querySelector("#cost-per-ppc-number").value;

	// the maths
	const toursNeeded = leases / (tourToLease / 100);
	const leadsNeededIls = toursNeeded / (leadToTour / 100);
	const leadsNeededPpc = toursNeeded / (leadToTour / 100);
	const leadsNeededOptimizedPpc = toursNeeded / 0.4;
	const totalSpendIls = ilsLeadCost * leadsNeededIls;
	const totalSpendOptimizedPpc = ppcLeadCost * leadsNeededOptimizedPpc;
	const total5050 = ilsLeadCost * (leadsNeededIls / 2) + ppcLeadCost * (leadsNeededPpc / 2);

	const costPerLeaseIls = totalSpendIls / leases;
	const costPerLeaseIlsPpc = total5050 / leases;
	const costPerLeasePpc = totalSpendOptimizedPpc / leases;

	// output to page
	document.querySelector("#leads-required-ils").innerText = leadsNeededIls.toLocaleString("en", {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});
	document.querySelector("#leads-required-ilsppc").innerText = leadsNeededPpc.toLocaleString("en", {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});
	document.querySelector("#leads-required-ppc").innerText = leadsNeededOptimizedPpc.toLocaleString("en", {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});

	document.querySelector("#tours-required-ils").innerText = toursNeeded.toLocaleString("en", {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});
	document.querySelector("#tours-required-ilsppc").innerText = toursNeeded.toLocaleString("en", {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});
	document.querySelector("#tours-required-ppc").innerText = toursNeeded.toLocaleString("en", {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});

	document.querySelector("#total-spend-ils").innerText = totalSpendIls.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});
	document.querySelector("#total-spend-ilsppc").innerText = total5050.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});
	document.querySelector("#total-spend-ppc").innerText = totalSpendOptimizedPpc.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});

	document.querySelector("#ils-spend").innerText = costPerLeaseIls.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});
	document.querySelector("#ils-ppc-spend").innerText = costPerLeaseIlsPpc.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});
	document.querySelector("#ppc-spend").innerText = costPerLeasePpc.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});

	// Makes the chart height dynamic
	const numbers = [totalSpendIls, total5050, totalSpendOptimizedPpc];
	const total = numbers.reduce((acc, num) => acc + num, 0);
	const minHeight = 20;
	const maxHeight = 180;
	const heights = numbers.map((num) => calculateHeight(num, total, minHeight, maxHeight));

	document.querySelector("#ils-spend-chart").style.height = heights[0] + "px";
	document.querySelector("#ils-ppc-spend-chart").style.height = heights[1] + "px";
	document.querySelector("#ppc-spend-chart").style.height = heights[2] + "px";
}

// Function to calculate height based on percentage
function calculateHeight(value, total, minHeight, maxHeight) {
	const percentage = value / total;
	return minHeight + (maxHeight - minHeight) * percentage;
}

// page load
calculateNumbers();

// advanced settings toggle
const toggle = document.querySelector(".show-hide-calc");
const inputGroups = document.querySelectorAll(".calculator-group--advanced");
toggle.addEventListener("click", function () {
	inputGroups.forEach(function (item) {
		item.classList.toggle("hidden");
	});
});
